@use "variables" as *;

.toolbarBox {
  display: flex;
  align-items: center;
  width: fit-content;
  margin: $spacing-s;
  border: 1px solid;
  border-radius: 4px;
  overflow: hidden;
}
